import type { Tone } from '@constants/tones';

export interface TimelineItem { title: string; detail?: string; tone: Tone }

/** Vertical history: a dot per entry on a rail, newest last. */
export function Timeline({ items }: { items: TimelineItem[] }) {
  return (
    <ol className="vtl">
      {items.map((r, i) => (
        <li key={i} className="vtl-item">
          <div className="vtl-rail">
            <span className={`vtl-dot tone-${r.tone}`} />
            <span className="vtl-line" />
          </div>
          <div className="vtl-body">
            <span className="vtl-title">{r.title}</span>
            {r.detail && <span className="vtl-detail">{r.detail}</span>}
          </div>
        </li>
      ))}
    </ol>
  );
}
